import { type TurnPool, BattleStatus, BattleUnit, HexPoint } from "@/core/types/battle.types"
import { BattleStore } from "@/store/useBattleStore";


export function mulberry32(seed: number) {
  return function () {
    let t = (seed += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function hashSeed(seed: string): number {
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}



/**
 * @param points - масив центрів гексів {x, y}
 * @param flattening - сила згладжування (0.1 - 0.5)
 * @param iterations - скільки разів пройтися по шляху (зазвичай 1-2 достатньо)
 */
export const smoothPath = (
    points: { x: number; y: number }[],
    isHill: boolean = false,
    flattening: number = 0.4, 
    iterations: number = 1
): HexPoint[] => {

    if (points.length < 3) return points;

    // Працюємо з копією масиву
    let smoothed = points.map(p => ({ ...p }));

    for (let iter = 0; iter < iterations; iter++) {
        // Створюємо тимчасовий масив для поточної ітерації
        const nextIter = smoothed.map(p => ({ ...p }));

        for (let i = 1; i < smoothed.length - 1; i++) {
            // Вказуємо TS, що ці елементи точно існують (!)
            const prev = smoothed[i - 1]!;
            const curr = smoothed[i]!;
            const next = smoothed[i + 1]!;
            const targetCell = nextIter[i]!;

            // Розраховуємо "бажану" позицію
            const targetX = (prev.x + next.x) / 2;
            const targetY = (prev.y + next.y) / 2;

            // LERP
            targetCell.x = curr.x + (targetX - curr.x) * flattening;
            targetCell.y = curr.y + (targetY - curr.y) * flattening;
        }
        smoothed = nextIter;
    }

    if (isHill) {
        const lastIndex = smoothed.length - 1;
        
        smoothed[lastIndex]!.y -= 20; 
    }

    

    return smoothed;
}

export function generateTurnQueue(units: any[]): TurnPool[] {
    // 1. Сортуємо за ініціативою (від вищої до нижчої)
    const sorted = [...units]
        .filter(u => u.count > 0)
        .sort((a, b) => b.stats.initiative - a.stats.initiative);

    const queue: TurnPool[] = [];
    if (sorted.length === 0) return queue;
    const faction = sorted[0].faction;
    let n = 1;
    // 2. Створюємо перший пул
    let currentPool: TurnPool = {
        id: `${faction}_${n}_${Date.now()}`,
        faction: faction,
        unitIds: [sorted[0].unitId]
    };

    // 3. Групуємо наступних юнітів, якщо вони тієї ж фракції
    for (let i = 1; i < sorted.length; i++) {
        const unit = sorted[i];
        if (unit.faction === currentPool.faction) {
            currentPool.unitIds.push(unit.unitId);
        } else {
            queue.push(currentPool);
            n = n + 1;
            currentPool = {
                id: `${unit.faction}_${n}_${Date.now()}`,
                faction: unit.faction,
                unitIds: [unit.unitId]
            };
        }
    }
    queue.push(currentPool);
    
    return queue;
}

export function getUnitTotalHp(unit: BattleUnit) {
    return ((unit.count - 1) * unit.stats.hp) + unit.currentUnitHp;
}

export function pauseToggle(state: BattleStore) {
    if (state.status === BattleStatus.Playing) {
        state.setStatus(BattleStatus.Paused);
    } else if (state.status === BattleStatus.Paused) {
        state.setStatus(BattleStatus.Playing);
    }
}


